import type * as ents from '@attain-apps/entities'
import type * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../../models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  /**
   * A set of action handler identifiers that are currently executing.
   */
  ongoingActionExecutionLookup: Partial<
    Record<models.action.Handler.Id, models.action.Handler.Context>
  >
  /**
   * Confirmation request action, used to show confirmation dialog
   */
  confirmationRequestAction?: store.actions.Action<
    State,
    store.actions.Op<string, 'request'>,
    {
      context: models.action.Handler.Context
    }
  >
}
export namespace State {
  export const INITIAL: State = {
    ongoingActionExecutionLookup: {},
  }

  /** TODO:  */
  export function addOngoingRequest(
    state: State,
    context: models.action.Handler.Context,
  ): State {
    return {
      ...state,
      ongoingActionExecutionLookup: {
        ...state.ongoingActionExecutionLookup,
        [context.id]: context,
      },
    }
  }

  /** TODO:  */
  export function deleteOngoingRequest(
    state: State,
    handlerId: models.action.Handler.Id,
  ): State {
    state = {
      ...state,
      ongoingActionExecutionLookup: {
        ...state.ongoingActionExecutionLookup,
      },
    }
    delete state.ongoingActionExecutionLookup[handlerId]

    return state
  }

  /**
   * Sets confirmation request in state which lets us show confirmation dialog
   */
  export function setConfirmationRequest(
    state: State,
    action: store.actions.Action<
      State,
      store.actions.Op<string, 'request'>,
      // TODO: Make this dry, e.g. create new type
      {
        context: models.action.Handler.Context
      }
    >,
  ): State {
    state = { ...state, confirmationRequestAction: action }
    return state
  }
  /**
   * Removes confirmationRequest from the state which removes confirmation
   * dialog
   *
   * Used in confirmAction reducers to remove dialog upon confirming or
   * cancelling action.
   */
  export function deleteConfirmationRequest(
    state: State,
    handlerId: models.action.Handler.Id,
  ): State {
    state = {
      ...state,
      confirmationRequestAction: undefined,
      ongoingActionExecutionLookup: { ...state.ongoingActionExecutionLookup },
    }
    delete state.ongoingActionExecutionLookup[handlerId]
    return state
  }
}
